import { useRef, useState } from "react";
import { UploadCloud } from "lucide-react";

export const Dropzone = ({ onFile, compact, title, steps }) => {
  const [over, setOver] = useState(false);
  const input = useRef(null);

  const onDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOver(false);
    onFile(e.dataTransfer.files);
  };

  return (
    <div className="fade-up" style={{ animationDelay: "120ms" }}>
      <button
        type="button"
        data-testid="pdf-dropzone"
        onClick={() => input.current?.click()}
        onDragOver={(e) => { e.preventDefault(); setOver(true); }}
        onDragLeave={() => setOver(false)}
        onDrop={onDrop}
        className={`dropzone group w-full rounded-2xl border-2 border-dashed px-6 ${compact ? "py-8" : "py-16 sm:py-24"} text-left sm:text-center ${over ? "border-emerald-500 bg-emerald-50" : "border-slate-300 bg-white hover:border-slate-400"}`}
      >
        <div className="flex flex-col sm:items-center gap-5">
          <div className={`w-14 h-14 rounded-xl flex items-center justify-center bg-slate-900 text-white dz-icon ${over ? "scale-110" : ""}`}>
            <UploadCloud className="w-7 h-7" />
          </div>
          <div>
            <p className="font-display text-xl sm:text-2xl font-bold text-slate-900">{compact ? "Aggiungi altri PDF" : title || "Trascina qui uno o più estratti conto PDF"}</p>
            <p className="mt-2 text-sm text-slate-500">oppure <span className="text-emerald-700 font-semibold underline underline-offset-4">clicca per selezionarli</span> · puoi sceglierne più di uno insieme · fino a 30 PDF, max 50 MB ciascuno</p>
          </div>
        </div>
      </button>
      <input
        ref={input}
        type="file"
        accept="application/pdf,.pdf"
        className="hidden"
        data-testid="pdf-file-input"
        multiple
        onChange={(e) => { onFile(e.target.files); e.target.value = ""; }}
      />
      {!compact && <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-3 text-xs text-slate-500">
        {(steps || ["1 · Scegli uno o più PDF", "2 · Premi Converti", "3 · Filtra e scarica Excel o CSV"]).map((s) => (
          <div key={s} className="rounded-lg border border-slate-200 bg-white/70 px-4 py-3 font-medium">{s}</div>
        ))}
      </div>}
    </div>
  );
};
